import React from "react";
import { useParams } from "react-router-dom";
import PlaylistContainer from "../../components/Playlist/PlaylistContainer";
import "./Playlist.css";

const ViewPlaylistPage: React.FC = () => {
    const { playlistId } = useParams<{ playlistId: string }>();

    if (!playlistId) {
        return (
            <div className="view-playlist-page">
                <div className="playlist-error">
                    <h2>Error</h2>
                    <p>No playlist ID provided.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="view-playlist-page">
            <PlaylistContainer playlistId={playlistId} />
        </div>
    );
};

export default ViewPlaylistPage;
